export default __webpack_public_path__ + "static/media/fit-horizontal.a3b4600a.svg";